// extracted by mini-css-extract-plugin
export default {"body":"PageWithHeaderAndFooter_body__Xu527","container":"PageWithHeaderAndFooter_container__xW8CR"};